<template>
  <div>
    <label v-if="label || $slots.label" :for="name" class="input-label">
      <slot name="label" :required="required" :attrs-name="name"
        >{{ label }} <span v-if="required" class="required-input">*</span></slot
      >
    </label>
    <div class="relative">
      <div :class="maxWidth">
        <div class="relative flex items-start">
          <LoadingIcon v-if="toggling" class="h-6 w-6 text-blue" />
          <div v-else class="flex items-center h-5">
            <input
              v-model="value"
              type="checkbox"
              :true-value="values[1]"
              :false-value="values[0]"
              :disabled="disabled"
              class="input-checkbox element-focus"
              :class="colorClass || 'input-checkbox-default'"
            />
          </div>
          <div class="ml-3 text-sm w-full text-left">
            <label class="text-gray-700"><slot /></label>
          </div>
        </div>
      </div>
    </div>
    <p
      v-if="displayedError || help"
      class="mt-1 text-sm"
      :class="{
        'text-gray-500': !displayedError,
        'text-red-600': displayedError,
      }"
    >
      {{ displayedError || help }}
    </p>
  </div>
</template>

<script>
import { useFieldValidation } from '@/api/useValidation'
import { computed } from 'vue'
export default {
  name: 'TCheckbox',
  props: {
    name: {
      type: String,
      default: '',
    },
    validator: {
      type: String,
      default: 'validator',
    },
    label: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: 'max-w-lg',
    },
    modelValue: {
      type: [Number, Boolean, String, Array, Object],
      required: true,
    },
    values: {
      type: Array,
      default: () => [false, true],
    },
    error: {
      type: [String, Array],
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toggling: {
      type: Boolean,
      default: false,
    },
    colorClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const value = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        context.emit('update:modelValue', value)
      },
    })
    return {
      value,
      ...useFieldValidation(props),
    }
  },
}
</script>
